import { HistoricTrendResponse } from "@core/api/useHistoricTrend";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export type HistoricTrendSelectedItem = {
	id: number;
	color: string;
}

export type HistoricTrendContextType = {
	activeSeriesId: number | null;
	setActiveSeriesId: (seriesId: number | null) => void;
	selectedItems: HistoricTrendSelectedItem[];
	setSelectedItems: Dispatch<SetStateAction<HistoricTrendSelectedItem[]>>;
	isLoading: boolean;
	setIsLoading: (isLoading: boolean) => void;
	data: HistoricTrendResponse;
	setData: (data: HistoricTrendResponse) => void;
};

const defaultContext: HistoricTrendContextType = {
	activeSeriesId: null,
	setActiveSeriesId: () => {},
	selectedItems: [],
	setSelectedItems: () => {},
	isLoading: false,
	setIsLoading: () => {},
	data: {},
	setData: () => {},
};

const HistoricTrendContext = createContext<HistoricTrendContextType>(defaultContext);

export const useHistoricTrendContext = () => {
	const context = useContext(HistoricTrendContext);
	if (!context) throw new Error("HistoricTrend context is not initialized");
	return context;
};

export default HistoricTrendContext;